// removed by extract-text-webpack-plugin
module.exports = {"resultItem":"dh-stemning-resultItem","resultItem__label":"dh-stemning-resultItem__label","resultItem__score-wrapper":"dh-stemning-resultItem__score-wrapper","resultItem__score":"dh-stemning-resultItem__score","resultItem__score--hidden":"dh-stemning-resultItem__score--hidden","resultItem__score-text":"dh-stemning-resultItem__score-text","score-text-wrapper":"dh-stemning-score-text-wrapper","resultList__sr":"dh-stemning-resultList__sr","resultList__bars":"dh-stemning-resultList__bars","resultList__text":"dh-stemning-resultList__text"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Result/components/ResultList/components/ResultItem/ResultItem.css
// module id = 9
// module chunks = 0 1 2